import { useEffect, useState } from 'react';
import { api, resolveImageUrl } from './api';

// ---------- store bersama (dashboard: Creators / Brand Booth / F&B / Floorplan) ----------
let state = { items: [], config: null, loaded: false, loading: false, error: '' };
const subs = new Set();
const emit = () => subs.forEach((f) => f(state));

export async function loadOnb() {
  if (state.loading) return;
  state = { ...state, loading: true };
  emit();
  try {
    const { data } = await api.get('/onboarding');
    state = { items: data.items || [], config: data.config || null, loaded: true, loading: false, error: '' };
  } catch (e) {
    state = { ...state, loading: false, loaded: true, error: (e && e.response && e.response.data && e.response.data.detail) || 'Gagal memuat data onboarding' };
  }
  emit();
}

export function putOnb(doc) {
  if (!doc || !doc.id) return;
  const items = state.items.some((d) => d.id === doc.id) ? state.items.map((d) => (d.id === doc.id ? { ...d, ...doc } : d)) : [doc, ...state.items];
  state = { ...state, items };
  emit();
}
export function dropOnb(id) { state = { ...state, items: state.items.filter((d) => d.id !== id) }; emit(); }
export function setOnbConfig(config) { state = { ...state, config }; emit(); }

export function useOnb() {
  const [s, setS] = useState(state);
  useEffect(() => {
    subs.add(setS);
    if (!state.loaded && !state.loading) loadOnb();
    return () => { subs.delete(setS); };
  }, []);
  return s;
}

export const onbKey = (src, refId) => `${src}:${refId}`;
export const onbIndex = (items) => {
  const m = {};
  (items || []).forEach((d) => { m[onbKey(d.src, d.ref_id)] = d; });
  return m;
};

// ---------- helper ----------
export const ONB_STATUS = {
  none: { label: 'Belum diundang', cls: 'bg-white text-black/60 border-black/20' },
  draft: { label: 'Belum diundang', cls: 'bg-white text-black/60 border-black/20' },
  invited: { label: 'Diundang', cls: 'bg-amber-100 text-amber-800 border-amber-500' },
  expired: { label: 'Expired', cls: 'bg-red-100 text-red-800 border-red-500' },
  awaiting_payment: { label: 'A1 OK - Menunggu bayar', cls: 'bg-sky-100 text-sky-800 border-sky-500' },
  payment_review: { label: 'Cek bukti bayar', cls: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-500' },
  dp: { label: 'DP', cls: 'bg-yellow-100 text-yellow-800 border-yellow-500' },
  paid: { label: 'Lunas', cls: 'bg-emerald-100 text-emerald-800 border-emerald-500' },
  cancelled: { label: 'Dibatalkan', cls: 'bg-gray-100 text-gray-600 border-gray-400' },
};
export const ONB_ORDER = ['invited', 'expired', 'awaiting_payment', 'payment_review', 'dp', 'paid'];
export const effStatus = (doc) => (!doc ? 'none' : doc.a1_expired ? 'expired' : doc.status);

export const rupiah = (v) => `Rp${Math.round(Number(v) || 0).toLocaleString('id-ID')}`;
export const parseDate = (v) => {
  if (!v) return null;
  const s = String(v);
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
  return isNaN(d) ? null : d;
};
export const fmtWhen = (v) => {
  const d = parseDate(v);
  return d ? d.toLocaleString('id-ID', { timeZone: 'Asia/Jakarta', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '-';
};
export const fmtDeadline = (v) => {
  const d = parseDate(v);
  return d ? `${d.toLocaleString('id-ID', { timeZone: 'Asia/Jakarta', weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })} WIB` : '-';
};
export const daysLeft = (v) => {
  const d = parseDate(v);
  if (!d) return null;
  return Math.ceil((d.getTime() - Date.now()) / 86400000);
};
export const normPhone = (p) => {
  let d = String(p || '').replace(/\D/g, '');
  if (d.startsWith('0')) d = `62${d.slice(1)}`;
  else if (d.startsWith('8')) d = `62${d}`;
  return d;
};
export const portalUrl = (doc) => `${window.location.origin}/portal/${doc.token}`;
export const receiptUrl = (doc) => {
  if (!doc || !doc.receipt_url) return '';
  const u = resolveImageUrl(doc.receipt_url);
  return /^https?:\/\//.test(u) ? u : `${window.location.origin}${u}`;
};
export const fillTpl = (tpl, doc) => String(tpl || '')
  .replace(/\{nama\}/g, doc.pic || doc.name || 'Kak')
  .replace(/\{brand\}/g, doc.name || '')
  .replace(/\{link\}/g, doc.token ? portalUrl(doc) : '')
  .replace(/\{booth\}/g, doc.booth_label || 'akan diinformasikan')
  .replace(/\{batas\}/g, fmtDeadline(doc.a1_deadline))
  .replace(/\{total\}/g, rupiah((doc.invoice && (doc.invoice.paid || doc.invoice.total)) || 0))
  .replace(/\{(invoice|kwitansi)\}/g, doc.status === 'paid' || doc.status === 'dp' ? receiptUrl(doc) : '');
export const waUrl = (phone, text) => {
  const p = normPhone(phone);
  return `https://wa.me/${p}?text=${encodeURIComponent(text || '')}`;
};
export const waTextFor = (doc, cfg) => {
  const c = cfg || {};
  if (doc.status === 'paid' || doc.status === 'dp') {
    const t = fillTpl(c.wa_paid, doc);
    const k = receiptUrl(doc);
    return k && !/\{(invoice|kwitansi)\}/.test(String(c.wa_paid || '')) ? `${t}\n\n${doc.status === 'paid' ? 'Invoice pelunasan' : 'Invoice DP (sisa ' + rupiah((doc.invoice && doc.invoice.due) || 0) + ')'} (PDF):\n${k}` : t;
  }
  if (doc.invited_at && doc.status !== 'invited') return fillTpl(c.wa_reminder, doc);
  return fillTpl(c.wa_invite, doc);
};
export const tenantFromReg = (src, r) => ({
  src,
  ref_id: r.id,
  name: String(r.brand_name || r.company_name || r.business_name || r.name || '').trim(),
  pic: r.pic_name || '',
  email: r.pic_email || '',
  phone: r.pic_phone || '',
  category: r.other_category || r.category || r.other_industry || r.industry || r.other_fnb_type || r.fnb_type || r.role || '',
});
export const errOf = (e, fb) => (e && e.response && e.response.data && e.response.data.detail) ? String(e.response.data.detail) : (fb || 'Terjadi kesalahan, coba lagi.');
